import request from "@/utils/request";

export function getCategories() {
  return request({
    url: "contactus/categories",
    method: "post",
  });
}

export function getContacts(Fserial, query) {
  return request({
    url: "contactus/search",
    method: "post",
    data: { Srl_Chart: Fserial, Query: query },
  });
}
